<template>
  <van-row id="register" style="display: flex; flex-direction: column; height: 100%; padding-top: 3rem;">
    <!-- NavBar part -->
    <mynavbar></mynavbar>

    <van-skeleton style="margin-top: 1rem;" title title-width="100%" :row="0" :loading="sloading" id="skeleton-title">
      <van-divider style="font-size: 1.2rem;">{{title}}</van-divider>
    </van-skeleton>

    <van-skeleton style="margin-top: 1rem;" title title-width="100%" :row="0" :loading="sloading" id="skeleton-title">
      <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o">
        注册信息提交成功后我们会尽快进行审核，请到会员单位中进行搜索与查看。
      </van-notice-bar>
    </van-skeleton>

    <!-- form part -->
    <van-skeleton :row="10" :loading="sloading" style="margin-top: 0.5rem;" id="skeleton-cell">
      <van-form @submit="onSubmit">
        <van-field
          v-model="name"
          name="会员名称"
          label="会员名称"
          placeholder="会员名称"
          :rules="[{ required: true, message: '请填写会员名称' }]"
        />
        <van-field
          v-model="company"
          name="单位名称"
          label="单位名称"
          placeholder="单位名称"
          :rules="[{ required: true, message: '请填写单位名称' }]"
        />
        <van-field
          v-model="address"
          name="地址"
          label="地址"
          placeholder="地址"
          :rules="[{ required: true, message: '请填写地址' }]"
        />
        <van-field
          v-model="code"
          name="邮编"
          label="邮编"
          placeholder="邮编"
          :rules="[{ required: true, message: '请填写邮编' }]"
        />
        <van-field
          v-model="email"
          name="邮箱"
          label="邮箱"
          placeholder="邮箱"
          :rules="[{ required: true, message: '请填写邮箱' }]"
        />
        <van-field
          readonly
          clickable
          name="mebPicker"
          :value="mebText"
          label="申请成为"
          placeholder="点击选择会员类型"
          @click="showMebPicker = true"
        />
        <van-popup v-model="showMebPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="columns"
            @confirm="selPicker"
            @cancel="showMebPicker = false"
            value-key="text"
          />
        </van-popup>
        <van-field name="uploader" label="申请表上传">
          <template #input>
            <van-uploader v-model="uploader" max-count=1 :after-read="afterRead" />
          </template>
        </van-field>

        <van-row style="text-align: right; margin-right: 1rem;">
          <a href="/static/file/20220107001.pdf" style="color: red;">申请表点击下载 <van-icon name="down" /></a>
        </van-row>
        <van-notice-bar
          wrapable
          :scrollable="false"
          text="请先下载申请表,按照表中要求进行填写,并上传扫描图片."
        />

        <!-- <van-field
          v-model="password"
          type="password"
          name="登录密码"
          label="登录密码"
          placeholder="登录密码"
          :rules="[{ required: true, message: '请填写登录密码' }]"
        /> -->
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </van-skeleton>

    <!-- footer part -->
    <!-- <myfooter></myfooter> -->

  </van-row>
</template>

<script>
import navbar from '@/view/navbar/navbar'
// import footer from '@/view/footer/footer'

import { Toast } from 'vant';
import { Notify } from 'vant';

// 图片处理
const Exif = require('exif-js')

const axios = require('axios')

export default {
  name: 'register',
  components: {
    'mynavbar' : navbar,
    // 'myfooter' : footer
  },
  data () {
    return {
      sloading: true,
      title: '',
      comShow: false,
      type: '',
      company: '',
      name: '',
      address: '',
      code: '',
      email: '',
      showMebPicker: false,
      mebText:'',
      level: null,
      sex: '',
      birthday: '',
      depname: '',
      duty: '',
      major: '',
      education: '',
      edcname: '',
      phone: '',
      columns: ['会员', '理事', '常务理事','副会长'],
      // columns: [
      //   {
      //     id: 0,
      //     text: '副会长'
      //   },
      //   {
      //     id: 1,
      //     text: '常务理事'
      //   },
      //   {
      //     id: 2,
      //     text: '理事'
      //   },
      //   {
      //     id: 3,
      //     text: '会员'
      //   },
      // ],
      uploader: [],
      // 图片信息
      files: {
        name: "",
        type: ""
      },
      fileimg: 0
    }
  },
  created() {
    var type = this.$route.params.type
    if(type == "personal") {
      this.title = "个人入会"
      this.type = 0
    }else if(type == "company") {
      this.title = "单位入会"
      this.type = 1
      this.comShow = true
    }
  },
  mounted() {
    this.sloading = false
  },
  methods: {
    // 会员选择
    selPicker(value,index) {
      this.level = index
      this.mebText = value
      // console.log(this.level)
      this.showMebPicker = false
    },

    // 文件上传组件方法 获取上传图片流
    afterRead(file) {
      this.files.name = file.file.name // 获取文件名
      this.files.type = file.file.type // 获取类型
      this.imgPreview(file.file)
    },
    // 处理图片
    imgPreview(file) {
      let self = this
      let Orientation
      //去获取拍照时的信息，解决拍出来的照片旋转问题   npm install exif-js --save   这里需要安装一下包
      Exif.getData(file, function() {
        Orientation = Exif.getTag(this, 'Orientation')
      })
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return
      if (/^image/.test(file.type)) {
        // 创建一个reader
        let reader = new FileReader()
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file)
        // 读取成功后的回调
        reader.onloadend = function() {
          let result = this.result
          let img = new Image()
          img.src = result
          //判断图片是否大于500K,是就直接上传，反之压缩图片
          if (this.result.length <= 500 * 1024) {
            // 上传图片
            self.postImg(this.result);
          } else {
            img.onload = function() {
              let data = self.compress(img, Orientation)
              // 上传图片
              self.postImg(data);
            }
          }
        }
      }
    },
    // 压缩图片
    compress(img, Orientation) {
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      //瓦片canvas
      let tCanvas = document.createElement('canvas')
      let tctx = tCanvas.getContext('2d')
      // let initSize = img.src.length;
      let width = img.width
      let height = img.height
      //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      let ratio
      if ((ratio = (width * height) / 4000000) > 1) {
        // console.log("大于400万像素");
        ratio = Math.sqrt(ratio)
        width /= ratio
        height /= ratio
      } else {
        ratio = 1
      }
      canvas.width = width
      canvas.height = height
      //    铺底色
      ctx.fillStyle = '#fff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      //如果图片像素大于100万则使用瓦片绘制
      let count
      if ((count = (width * height) / 1000000) > 1) {
        // console.log("超过100W像素");
        count = ~~(Math.sqrt(count) + 1) //计算要分成多少块瓦片
        //      计算每块瓦片的宽和高
        let nw = ~~(width / count)
        let nh = ~~(height / count)
        tCanvas.width = nw
        tCanvas.height = nh
        for (let i = 0; i < count; i++) {
          for (let j = 0; j < count; j++) {
            tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh)
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh)
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height)
      }
      //修复ios上传图片的时候 被旋转的问题
      if (Orientation != '' && Orientation != 1) {
        switch (Orientation) {
          case 6: //需要顺时针（向左）90度旋转
            this.rotateImg(img, 'left', canvas)
            break
          case 8: //需要逆时针（向右）90度旋转
            this.rotateImg(img, 'right', canvas)
            break
          case 3: //需要180度旋转
            this.rotateImg(img, 'right', canvas) //转两次
            this.rotateImg(img, 'right', canvas)
            break
        }
      }
      //进行最小压缩
      let ndata = canvas.toDataURL('image/jpeg', 0.1)
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      console.log(ndata)
      return ndata
    },
    // 旋转图片
    rotateImg(img, direction, canvas) {
      //最小与最大旋转方向，图片旋转4次后回到原方向
      const min_step = 0
      const max_step = 3
      if (img == null) return
      //img的高度和宽度不能在img元素隐藏后获取，否则会出错
      let height = img.height
      let width = img.width
      let step = 2
      if (step == null) {
        step = min_step
      }
      if (direction == 'right') {
        step++
        //旋转到原位置，即超过最大值
        step > max_step && (step = min_step)
      } else {
        step--
        step < min_step && (step = max_step)
      }
      //旋转角度以弧度值为参数
      let degree = (step * 90 * Math.PI) / 180
      let ctx = canvas.getContext('2d')
      switch (step) {
        case 0:
          canvas.width = width
          canvas.height = height
          ctx.drawImage(img, 0, 0)
          break
        case 1:
          canvas.width = height
          canvas.height = width
          ctx.rotate(degree)
          ctx.drawImage(img, 0, -height)
          break
        case 2:
          canvas.width = width
          canvas.height = height
          ctx.rotate(degree)
          ctx.drawImage(img, -width, -height)
          break
        case 3:
          canvas.width = height
          canvas.height = width
          ctx.rotate(degree)
          ctx.drawImage(img, -width, 0)
          break
      }
    },
    //将base64转换为文件
    dataURLtoFile(dataurl) {
      var arr = dataurl.split(','),
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], this.files.name, {
        type: this.files.type
      })
    },
    // 提交图片到后端
    postImg(base64) {
      let that = this
      let file = this.dataURLtoFile(base64)
      let formData = new window.FormData()
      formData.append('file', file)
      // 提交图片
      // console.log('提交图片')
      // file upload
      axios({
        method: 'post',
        url: that.global.apiUrl + "/web/file",
        headers:{'Content-Type':'multipart/form-data'},
        data:formData
      })
      .then(function (response) {
        // Toast.success({
        //   message: '提交成功',
        //   duration: 2000,
        // })
        // console.log(response)
        that.fileimg = response.data.data.id
      })
      .catch(function(error){
        Toast.fail({
          message: '图片上传异常',
          duration: 2000,
        })
        console.log(error)
      })

    },

    // 提交数据
    onSubmit(values) {
      let that = this
      // console.log('submit', values)
      if(this.level < 0 || this.level == null) {
        Notify({ type: 'danger', message: '请选择会员类型' })
        return false
      }
      if(this.fileimg == 0 || this.fileimg == '' || this.fileimg == null) {
        Notify({ type: 'danger', message: '请上传申请表' })
        return false
      }
      var data = {
        type: this.type,
        company: this.company,
        name: this.name,
        address: this.address,
        code: this.code,
        email: this.email,
        level: this.level,
        fileimg: this.fileimg,
        // sex: this.sex,
        // birthday: this.birthday,
        // depname: this.depname,
        // duty: this.duty,
        // major: this.major,
        // education: this.education,
        // edcname: this.edcname,
        // phone: this.phone,
      }
      // post请求
      // axios.post('http://localhost:8082/member', data)
      //   .then( function(response) {
      //     console.log(response)
      // })

      axios({
        method: 'post',
        url: that.global.apiUrl + "/web/member",
        // headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},
        data:data
      })
      .then(function (response) {
        // Toast.success({
        //   message: '提交成功',
        //   duration: 2000,
        //   onClose: onClose
        // })
        let toast = Toast({message:"提交成功",type:"success"})
        setTimeout(()=>{undefined
          toast.clear()
          that.$router.push({ name: 'member' })
        },2000)
        // console.log(response)
      })
      .catch(function(error){
        Toast.fail({
          message: '提交异常',
          duration: 2000,
        })
        console.log(error)
      });

    },

    // Toast关闭回调
    onClose () {
      this.$router.push({ name: 'member'})
    },

  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/view/register/register.vue